import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Swal from "sweetalert2";
import api3001 from "../../services/api3001";

const color = {
  verde: "#16a34a",
  vermelho: "#dc2626"
};

const Input = styled.input`
  padding: 6px 10px;
  border-radius: 6px;
  border: 2px solid ${({ $cor }) => $cor};
  outline: none;
  width: 140px;
  font-weight: 600;
  text-align: center;
`;


const InputKmRealizado = ({
  $km,
  $orcamento_id,
  $load
}) => {
  const token = localStorage.getItem("token");

  const formatBR = (value) => {
    if (!value) return "";
    return Number(value).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const parseBR = (value) => {
    if (!value) return 0;
    return Number(
      value
        .replace(/\./g, "")
        .replace(",", ".")
    );
  };

  const [valor, setValor] = useState(formatBR($km));

  useEffect(() => {
    setValor(formatBR($km));
  }, [$km]);

  const numeroLimpo = parseBR(valor);
  const isValido = numeroLimpo > 0;

  const handleChange = (e) => {
    const raw = e.target.value;

    // Remove tudo que não for número
    const onlyNumbers = raw.replace(/\D/g, "");

    if (!onlyNumbers) {
      setValor("");
      return;
    }

    const number = Number(onlyNumbers) / 100;

    setValor(formatBR(number));
  };

  const handleSalvar = async () => {
    if (!numeroLimpo || numeroLimpo <= 0) {
      Swal.fire("Atenção", "Informe um KM válido maior que zero.", "warning");
      return;
    }

    const confirm = await Swal.fire({
      title: "Confirmar KM realizado?",
      text: `KM informado: ${formatBR(numeroLimpo)} km`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não"
    });

    if (!confirm.isConfirmed) return;

    try {
      await api3001.put(
        `/api/orcamento/${$orcamento_id}`,
        { km_total_realizado: numeroLimpo },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      Swal.fire("Sucesso", "KM realizado atualizado com sucesso!", "success");

      $load?.();
    } catch (error) {
      Swal.fire("Erro", "Erro ao atualizar KM realizado.", "error");
    }
  };

  return (
    <Input
      type="text"
      value={valor}
      $cor={isValido ? color.verde : color.vermelho}
      onChange={handleChange}
      onBlur={handleSalvar}
      placeholder="0,00"
    />
  );
};

export default InputKmRealizado;